var $ = global.jQuery = global.$;
var parser = require('../lib/parser');
var ps = require('../lib/ps');
var widgets = require('../lib/widgets');

var take = require('lodash/array/take');
var takeRight = require('lodash/array/takeRight');

var _Base = require('./_Base');
/**
 * Widget for building and interacting with a filter row
 * @class
 * @extends _Base
 */
var FilterRow = _Base.extend(
  /** @lends FilterRow.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.suppressEvents = false;

    this.$list = this.$el.find('[data-filter-list]');

    this.$el.on('Select:optionsUpdated', function(event, updatedOpts) {
      self.options = updatedOpts;
      self.buildRow();
    });

  },
  /**
   * Fires once when all widgets are loaded
   * @private
   */
  onWidgetsReady: function() {
    this.$el.on('Select:optionsUpdated', this._selectOptionsUpdatedHandler.bind(this));

    this.select = widgets.getDescendants(this.$el, 'CustomSelect')[0];
    this.Options = this.select.selectOptions;
    this.Name = this.select.name;

    this.buildRow();
  },
  /**
   * Change filter options and build the updated row when select options get updated
   * @param {object} event
   * @param {Object[]} updatedOpts - An object of properties for each new select option
   * @param {string} updatedOpts[].Text - The text value of the new select option.
   * @param {string|number} updatedOpts[].Value - The value of the new select option.
   * @param {bool} [updatedOpts[].Selected] - Whether or not this option is selected.
   * @private
   */
  _selectOptionsUpdatedHandler: function(event, updatedOpts) {
    this.options = updatedOpts;
    this.buildRow();
  },
  /**
   * Update the underlying select options. Simply a passthrough to the select updateSelectOptions() method
   * @param {Object[]} newOpts - An object of properties for each new select option
   * @param {string} newOpts[].Text - The text value of the new select option.
   * @param {string|number} newOpts[].Value - The value of the new select option.
   * @param {bool} [newOpts[].Selected] - Whether or not this option is selected.
   */
  updateOptions: function(newOpts) {
    this.select.updateSelectOptions(newOpts);
  },
  /**
   * Build the row from the select options
   */
  buildRow: function() {
    var self = this;
    var tmpl = require('templates/filterItemOption.dot');
    var archTmpl = require('templates/filterArchive.dot');
    var needsArchive = this.Options.length > 6 && this.Name === 'Year';
    var opts = needsArchive ? take(this.Options, 6) : this.Options;
    var archiveOpts = takeRight(this.Options, this.Options.length - 6);

    if (this.Options.length)

      this.$list.find('[data-filter-built]').remove();

    this.$list.append(tmpl(opts));

    if (needsArchive) this.$list.append(archTmpl(archiveOpts));

    this.attachRowHandlers();
  },
  /**
   * Change select value when indiviudal row filter option is clicked
   * @private
   */
  _triggerClickHandler: function(event) {
    var self = event.data.self;
    event.preventDefault();
    self.select.setValue($(this).data('value'));
  },
  /**
   * Show/hide archive menu when toggle is clicked
   * @private
   */
  _archiveToggleClickHandler: function(event) {
    var self = event.data.self;
    var $archive = event.data.$archive;
    event.preventDefault();
    if (!$archive.hasClass('is-open')) {
      $archive
        .addClass('is-open')
        .velocity({
          'scaleY': '1'
        }, {
          'display': 'block'
        });
    } else {
      $archive
        .removeClass('is-open')
        .velocity({
          'scaleY': ['0', 'ease-out']
        }, {
          'duration': 600,
          'display': 'none'
        });
    }
  },
  /**
   * Close archive toggle when clicked outside archive
   * @private
   */
  _clickOutsideHandler: function(event) {
    var $archive = event.data.$archive;
    var $archiveToggle = event.data.$archiveToggle;
    if (!$(event.target).closest($archiveToggle).length && $archive.hasClass('is-open')) {
      $archive
        .removeClass('is-open')
        .velocity({
          'scaleY': '0'
        }, {
          'display': 'none'
        });
    }
  },
  /**
   * Update filter triggers state when underlying select changes
   * @private
   */
  _fieldUpdateHandler: function(event, name, value) {
    var self = event.data.self;
    var $archive = event.data.$archive;
    var $triggers = event.data.$triggers;

    $triggers.removeClass('is-current');

    $triggers.each(function() {
      var $this = $(this);
      if ($this.data('value') + '' === value) {
        $this.addClass('is-current');
        if ($this.hasClass('is-archive')) {
          $archive.parents('.filter__item').addClass('is-current');
        } else {
          $archive.parents('.filter__item').removeClass('is-current');
        }
      }
    });

    if (!self.suppressEvents) self.$el.trigger('Row:changed', [name, value]);
  },
  /**
   * Attach events to the filter rows for archive, field update etc.
   */
  attachRowHandlers: function() {
    var self = this;
    var $triggers = this.$el.find('[data-filter-item-option]');
    var $archiveToggle = this.$el.find('[data-filter-archive-toggle]');
    var $archive = this.$el.find('[data-filter-archive]');

    $archive.velocity({
      'scaleY': '0'
    }, {
      'display': 'none'
    });

    $triggers.on('click', {
      self: this
    }, this._triggerClickHandler);

    $archiveToggle.on('click', {
      self: this,
      $archive: $archive
    }, this._archiveToggleClickHandler);

    $(document).on('click', {
      self: this,
      $archive: $archive,
      $archiveToggle: $archiveToggle
    }, this._clickOutsideHandler);

    this.$el.on('Field:updated', {
      self: this,
      $archive: $archive,
      $triggers: $triggers
    }, this._fieldUpdateHandler);

  },
  /**
   * Reset the row to have the first option selected
   */
  reset: function() {
    this.suppressEvents = true;
    this.select.setSelectIndex(0);
    this.suppressEvents = false;
  }
});

module.exports = FilterRow;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/FilterRow.js
 ** module id = 236
 ** module chunks = 0 1
 **/